var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraceTime(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.523,
    height: 19.546,
    viewBox: "0 0 19.523 19.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-5.65 -3.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61415",
    "data-name": "Path 61415",
    d: "M19.887,5.706A8.994,8.994,0,1,0,23.173,18",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fd0e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61416",
    "data-name": "Path 61416",
    d: "M7,9v4",
    transform: "translate(15.422 0.166)",
    fill: "none",
    stroke: "#fd0e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61417",
    "data-name": "Path 61417",
    d: "M5,11H9",
    transform: "translate(15.422 0.185)",
    fill: "none",
    stroke: "#fd0e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61418",
    "data-name": "Path 61418",
    d: "M18.08,16.67l-3.1-1.85A2.215,2.215,0,0,1,14,13.1V9",
    transform: "translate(0.237 0.228)",
    fill: "none",
    stroke: "#fd0e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraceTime);
export default __webpack_public_path__ + "static/media/grace-time.38192bdef3009c177378311b0d66a08d.svg";
export { ForwardRef as ReactComponent };